export const logsEventLevels = {
	error: 'error',
	info: 'info'
};

export const logsTypes = {
	event: 'event',
	comment: 'comment'
};
